import React, { useEffect, useRef, useState } from 'react';
import './WhoWeAre.css';

const skillsData = [
  { name: 'Service', percentage: 110 },
  { name: 'Design', percentage: 100 },
  { name: 'Engineering', percentage: 95 },
  { name: 'Quality', percentage: 100 },
];

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

const CircularSkill = ({ name, percentage, isVisible, index }) => {
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const clamped = clamp(percentage, 0, 100);
  const offset = circumference - (isVisible ? (clamped / 100) * circumference : 0);

  return (
    <div
      className={`circular-skill ${isVisible ? 'show' : ''}`}
      style={{ transitionDelay: `${index * 120}ms` }}
    >
      <svg className="progress-ring" width="120" height="120">
        <circle className="progress-ring-bg" cx="60" cy="60" r={radius} />
        <circle
          className="progress-ring-fill"
          cx="60"
          cy="60"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>

      <span className="percentage-label">
        {percentage}%
      </span>

      <p className="skill-label">{name}</p>
    </div>
  );
};

const WhoWeAre = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Re-trigger every time the section enters/leaves the viewport
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="who-we-are-wrapper" ref={sectionRef}>
      {/* floating bubbles background */}
      <div className="background-bubbles" aria-hidden="true">
        <span></span><span></span><span></span><span></span><span></span>
      </div>

      <div className={`who-we-are-content ${isVisible ? 'visible' : ''}`}>
        <div className="who-text">
          <h2>
            Who <b>We Are</b>
          </h2>
          <p>
            We create <strong>innovative</strong> lighting solutions that merge
            design with <strong>engineering</strong> excellence. Our vision is to
            deliver <strong>smarter</strong> and <strong>lasting</strong> experiences.
          </p>
        </div>

        <div className="who-skills">
          {skillsData.map((skill, i) => (
          <CircularSkill
            key={skill.name}
            name={skill.name}
            percentage={skill.percentage}
            isVisible={isVisible}
            index={i}
          />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
